export const SET_QUESTIONS_LIST = "questions/SET_QUESTIONS_LIST"
export const ADD_NEW_QUESTION_TO_LIST = "questions/ADD_NEW_QUESTION_TO_LIST"
export const CLEAR_QUESTIONS_LIST = "questions/CLEAR_QUESTIONS_LIST"
export const OPEN_ADD_VARIABLE_MODAL = "exercises/OPEN_ADD_VARIABLE_MODAL"
export const CLOSE_ADD_VARIABLE_MODAL = "exercises/CLOSE_ADD_VARIABLE_MODAL"
export const SELECT_EXERCISE_FOR_ADD_VARIABLE_MODAL = "exercises/SELECT_EXERCISE_FOR_ADD_VARIABLE_MODAL"
